module.exports = __webpack_public_path__ + "img/45Trump.105cce70.png";